import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import LoadingSpinner from 'shared/components/ui/loadingSpinner';
import CartList from 'components/cart/list';
import FreeShippingMeter from 'components/cart/freeShippingMeter';
import LineItem from 'components/cart/LineItem';
import Promo from 'components/promo';
import { showPromo } from 'components/promo/actions';
import { selectPromo, removePromo } from 'components/cart/actions';
import { hidden } from 'scy/display.mod.scss';
import PromoForm from 'components/promo/form';
import { track } from 'shared/models/analytic';
import { discount } from 'components/cart/preview.mod.scss';
import margin from 'scy/margin.mod.scss';
import padding from 'scy/padding.mod.scss';
import border from 'scy/border.mod.scss';
import SummaryToggle from './SummaryToggle';
import styles from 'components/checkoutPage/styles.mod.scss';

class Cart extends React.Component {
  constructor(props) {
    super(props);
    this.state = { collapsed: true };
    this.toggleCollapsed = this.toggleCollapsed.bind(this);
  }

  componentDidUpdate(prevProps) {
    const prevCodes = (prevProps.userPromo || {}).codes || [];
    const nextCodes = (this.props.userPromo || {}).codes || [];
    // Promo code has been added, e.g. by logging in or signing up
    if (nextCodes.length && nextCodes.length !== prevCodes.length) {
      this.props.selectPromo(nextCodes[0], { checkout: true });
    }
  }

  toggleCollapsed() {
    this.setState(prevState => ({ collapsed: !prevState.collapsed }));
  }

  render() {
    const products = this.props.products || [];
    const engravings = this.props.engravings || [];
    const hasShippingMeter = !!this.props.subtotal && this.props.shipping;
    const subtotal = this.props.subtotal;
    const originalSubtotal = products
      .concat(engravings)
      .filter(p => p.originalSubtotal || p.subtotal)
      .reduce((sum, p) => sum + (p.originalSubtotal || p.subtotal), 0);
    const showDiscount = originalSubtotal - subtotal >= 0.01;
    const promoCodes = (this.props.userPromo || {}).codes || [];
    const showInlinePromo = !!products.length && !promoCodes.length;
    const lineItems = showInlinePromo
      ? this.props.line_items.filter(({ title }) => title !== 'Promo Code')
      : this.props.line_items;

    return (
      <>
        <SummaryToggle
          showTotal={!!products.length}
          total={(this.props.total || 0).toFixed(2)}
          collapsed={this.state.collapsed}
          toggleCollapsed={this.toggleCollapsed}
        />

        <div
          className={classnames(styles.cart, {
            [hidden]: this.state.collapsed,
            [styles.bannerPadding]: this.props.hasBanner
          })}
        >
          {hasShippingMeter && (
            <FreeShippingMeter subtotal={this.props.subtotal} />
          )}

          <CartList
            checkout
            className={styles.cartList}
            onClick={this.props.openQuickView}
          />

          {showInlinePromo && (
            <PromoForm
              className={classnames(
                margin.left_sm,
                margin.right_sm,
                padding.top_sm,
                border.topMedium
              )}
              placeholder="Promo Code"
              isDisabled={!this.props.user}
              errorMessage={
                !this.props.user
                  ? 'Please log in or sign up to apply a promo.'
                  : null
              }
              orderId={this.props.orderId}
              onSuccess={promo => {
                track('Coupon Applied', {
                  order_id: this.props.orderId,
                  coupon_id: promo.code,
                  coupon_name: promo.desc,
                  discount: promo.val
                });
                return this.props.selectPromo(promo, { checkout: true });
              }}
            />
          )}

          {!!subtotal && (
            <div className={styles.lineItems}>
              {this.props.loading && <LoadingSpinner black />}
              {lineItems.map(line => (
                <LineItem
                  key={line.title + '-' + line.display}
                  {...line}
                  showPromo={() => this.props.showPromo(true)}
                />
              ))}
              {showDiscount && (
                <div className={discount}>
                  You saved ${(originalSubtotal - subtotal).toFixed(2)}
                </div>
              )}
            </div>
          )}
        </div>

        {!showInlinePromo && (
          <Promo
            selectPromo={item =>
              this.props.selectPromo(item, { checkout: true })
            }
            selectedPromo={this.props.promo}
            removePromo={() => this.props.removePromo({ checkout: true })}
            orderId={this.props.orderId}
          />
        )}
      </>
    );
  }
}

const ConnectedCart = connect(
  state => ({
    ...state.cart,
    orderId: state.checkout.id,
    shipping: state.address.shipping,
    userPromo: state.promo,
    user: state.login.user
  }),
  {
    showPromo,
    selectPromo,
    removePromo
  }
)(Cart);

export default ConnectedCart;
